module.exports = __webpack_public_path__ + "img/Skull Mask Esport Logo Template.jpg";